<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        {{ pageTitle }}
        <v-btn
          class="mx-2"
          fab
          small
          dark
          color="indigo"
          :title="`Novo ${singularLabel}`"
          @click="createItem"
        >
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          clearable
        />
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="sortedSizes"
        :search="search"
        :loading="loading"
        loading-text="Buscando tamanhos..."
        no-data-text="Nenhum tamanho cadastrado."
      >
        <template v-slot:item.active="{ item }">
          <v-chip small dark :color="item.active !== false ? 'green' : 'grey'">
            {{ item.active !== false ? "Ativo" : "Inativo" }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-3" title="Editar" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon
            v-if="item.active !== false"
            small
            color="red"
            title="Desativar"
            @click="requestDelete(item)"
          >
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <size-form-dialog
      v-model="formDialog"
      :type="type"
      :size="selectedSize"
      @saved="handleSaved"
      @error="handleError"
    />
    <size-delete-dialog
      v-model="deleteDialog"
      :type="type"
      :size="selectedSize"
      @deleted="handleDeleted"
      @error="handleError"
    />

    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" top>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.visible = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import SizeDeleteDialog from "../../components/admin/sizes/SizeDeleteDialog.vue";
import SizeFormDialog from "../../components/admin/sizes/SizeFormDialog.vue";
import { getSizes } from "../../services/sizes";

export default {
  name: "SizeList",
  components: {
    SizeDeleteDialog,
    SizeFormDialog,
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ["clothes", "shoes"].includes(value),
    },
  },
  data() {
    return {
      search: "",
      loading: true,
      sizes: [],
      selectedSize: null,
      formDialog: false,
      deleteDialog: false,
      unsubscribe: null,
      snackbar: {
        visible: false,
        text: "",
        color: "green",
      },
      headers: [
        { text: "Tamanho", value: "value" },
        { text: "Descrição", value: "text" },
        { text: "Ordem", value: "order" },
        { text: "Status", value: "active" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    pageTitle() {
      return this.type === "clothes"
        ? "Tamanhos de Roupa"
        : "Tamanhos de Sapato";
    },
    singularLabel() {
      return this.type === "clothes" ? "tamanho de roupa" : "tamanho de sapato";
    },
    sortedSizes() {
      return [...this.sizes].sort((first, second) => {
        const firstOrder = Number(first.order);
        const secondOrder = Number(second.order);
        if (firstOrder !== secondOrder) return firstOrder - secondOrder;

        if (this.type === "shoes") {
          return Number(first.value) - Number(second.value);
        }
        return String(first.value).localeCompare(String(second.value));
      });
    },
  },
  watch: {
    type() {
      this.subscribe();
    },
  },
  mounted() {
    this.subscribe();
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    subscribe() {
      if (this.unsubscribe) this.unsubscribe();
      this.loading = true;
      this.sizes = [];
      this.unsubscribe = getSizes(this.type).onSnapshot(
        (snapshot) => {
          this.sizes = snapshot.docs.map((document) => ({
            id: document.id,
            ...document.data(),
          }));
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.handleError(error);
        }
      );
    },
    createItem() {
      this.selectedSize = null;
      this.formDialog = true;
    },
    editItem(size) {
      this.selectedSize = { ...size };
      this.formDialog = true;
    },
    requestDelete(size) {
      this.selectedSize = { ...size };
      this.deleteDialog = true;
    },
    handleSaved({ message }) {
      this.showSnackbar(message, "green");
    },
    handleDeleted() {
      this.showSnackbar("Tamanho desativado com sucesso.", "green");
    },
    handleError(error) {
      console.error(error);
      this.showSnackbar("Não foi possível concluir a operação.", "red");
    },
    showSnackbar(text, color) {
      this.snackbar = {
        visible: true,
        text,
        color,
      };
    },
  },
};
</script>
